import { Platform } from 'react-native';
import { SDK_VERSION } from './utils/version';

class DeviceInfo {
  private deviceInfo: any;

  constructor() {
    this.deviceInfo = {
      isMobile: true,
      isReactNative: true,
      osName: Platform.OS,
      osVersion: Platform.Version,
      reactNativeVersion: this.getReactNativeVersion(),
      sdkType: 'realtimekit-react-native',
      reactNativeSdkVersion: this.getSdkVersion(),
    };
  }

  private getSdkVersion() {
    return SDK_VERSION;
  }

  private getReactNativeVersion() {
    const version = Platform.constants.reactNativeVersion;
    return version.major + '.' + version.minor + '.' + version.patch;
  }

  getDeviceInfo() {
    return this.deviceInfo;
  }
}

export default new DeviceInfo();
